import { GetEventResponse, PostEventType } from '@orbit/api-types'
import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCreateEvent = () => {
	const queryClient = useQueryClient()

	return useMutation<GetEventResponse, Error, { tripId: string; eventData: PostEventType }>({
		mutationFn: async ({ tripId, eventData }) => {
			const response = await api.post<GetEventResponse>(`/trips/${tripId}/events`, eventData)
			return response.data
		},
		onSuccess: (_, variables) => {
			// Invalidate and refetch events for this trip
			queryClient.invalidateQueries({ queryKey: ['events', variables.tripId] })
		},
	})
}
